import { GetAllEntitiesResponse } from 'domain/models';
import { EntityType } from 'domain/value-objects/entities-type';
import personIcon from 'presentation/app/assets/images/icon-person.jpeg';
import { TableColumn } from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';

export const makeColumnsEntities =
  (): TableColumn<GetAllEntitiesResponse>[] => {
    const navigate = useNavigate();
    const getEntityTypeDescription = (type: EntityType): string => {
      switch (type) {
        case EntityType.Company:
          return 'Empresa';
        case EntityType.Institution:
          return 'Instituição de Ensino';
        case EntityType.PublicAgency:
          return 'Órgão Público';
        default:
          return 'Desconhecido';
      }
    };

    const formatAddress = (address: {
      street: string;
      number: string;
      neighborhood: string;
      city: { name: string };
    }): string => {
      return `${address?.street}, ${address?.number} - ${address?.neighborhood} - ${address?.city?.name}`;
    };

    return [
      {
        name: 'Nome',
        selector: (row) => row.name,
        wrap: true,
        sortable: true,
        width: '530px',
        cell: (row) => (
          <div className="d-flex align-items-center gap-3 py-2 cursor-pointer">
            <img
              src={row?.photo || personIcon}
              alt="Foto da pessoa"
              className="avatar object-fit-cover"
            />
            <div className="d-flex flex-column">
              <span>
                <strong
                  onClick={() => {
                    navigate('/organizacao/' + row?.id);
                  }}
                >
                  {row?.name}
                </strong>
              </span>
            </div>
          </div>
        ),
      },
      {
        name: 'Tipo',
        selector: (row) => getEntityTypeDescription(row.type as EntityType),
        sortable: true,
        width: '400px',
      },
      {
        name: 'Localização',
        width: '400px',
        selector: (row) => row.address?.city?.name,
        sortable: true,
        cell: (row) => <span>{formatAddress(row.address)}</span>,
      },
      {
        name: '',
      },
    ];
  };
